import {
    UPDATE_DISCOUNT_GROUP_REQUEST,
    UPDATE_DISCOUNT_GROUP_SUCCESS,
    UPDATE_DISCOUNT_GROUP_FAILURE,
  } from "../actions/types";
  
  const initialState = {
    isLoading: false,
    error: null,
    selectedDiscountGroup: null,
  };
  
  export const pgmDiscountGroupUpdateReducer = (state = initialState, action) => {
    switch (action.type) {
      case UPDATE_DISCOUNT_GROUP_REQUEST:
        return { ...state, isLoading: true };
  
      case UPDATE_DISCOUNT_GROUP_SUCCESS:
        return {
          ...state,
          isLoading: false,
          selectedDiscountGroup: action.payload?.discount_group_id,
        };
  
      case UPDATE_DISCOUNT_GROUP_FAILURE:
        return { ...state, isLoading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  